import React from "react";

// Simple cart store backed by localStorage (no external deps)
const load = () => {
  try {
    return JSON.parse(localStorage.getItem("ng_cart") || "[]");
  } catch {
    return [];
  }
};
const save = (items) => localStorage.setItem("ng_cart", JSON.stringify(items));

let listeners = new Set();
let items = load();

const notify = () => listeners.forEach((l) => l(items));

export const cartStore = {
  get: () => items,
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  add: (item) => {
    const existingIdx = items.findIndex((i) => i.product_id === item.product_id);
    if (existingIdx >= 0) {
      items = items.map((i, idx) => (idx === existingIdx ? { ...i, ...item } : i));
    } else {
      items = [...items, item];
    }
    save(items);
    notify();
  },
  remove: (product_id) => {
    items = items.filter((i) => i.product_id !== product_id);
    save(items);
    notify();
  },
  clear: () => {
    items = [];
    save(items);
    notify();
  },
};

export const useCart = () => {
  const [, setState] = React.useState(0);
  React.useEffect(() => cartStore.subscribe(() => setState((x) => x + 1)), []);
  const current = cartStore.get();
  return {
    items: current,
    add: cartStore.add,
    remove: cartStore.remove,
    clear: cartStore.clear,
    total: current.reduce((s, i) => s + Number(i.line_total || 0), 0),
    count: current.length,
  };
};
